export default __webpack_public_path__ + "static/service-engineering-a49debd29fab36c56d7a3dad2269b3c3.svg";